import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import LookupSearch from './LookupSearch';

const Lookup = () => {
  return (
    <Page title='Logirate | Look Up'>
      <PageLayout>
        <Container>
          <Header>Look Up</Header>
          <LookupSearch />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default Lookup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
`;
